import { ApolloError } from '@apollo/client';

import { fetchProfileFailure } from 'src/components/Profile/actionCreators';
import { Actions, type LoadingAction } from 'src/reducers/loading';
import type { ReduxInjections, Action } from 'src/types';

const numFailedQueriesToTriggerErrorPage = 3;

export const createLoadingMiddleware =
  () =>
  ({ getState, dispatch }: ReduxInjections) =>
  (next: (action: Action) => void) =>
  (action: LoadingAction) => {
    const { type } = action;

    if (type === Actions.QUERY_FAILURE) {
      next(action); // Dispatch action to run reducer before proceeding with below code

      const state = getState();
      const failedQueriesCount = Object.keys(state.loading).length;
      const { profileLoadError } = state.profile;

      if (
        failedQueriesCount >= numFailedQueriesToTriggerErrorPage &&
        !profileLoadError
      ) {
        dispatch(
          fetchProfileFailure(
            new ApolloError({
              errorMessage: `${failedQueriesCount} queries failed to return successfully: ${JSON.stringify(
                Object.keys(state.loading),
              )}`,
            }),
          ),
        );
      }
    } else {
      return next(action);
    }
  };
